import { render, staticRenderFns } from "./card-recap-only-stay.vue?vue&type=template&id=0b804707"
import script from "./card-recap-only-stay.vue?vue&type=script&lang=js"
export * from "./card-recap-only-stay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports